/**
 * Same selection rules as mobile `Subject` filter.
 * `options[0]` is the "All …" sentinel.
 */
export function nextMultiSelectValue(
  selected: string[],
  options: readonly string[],
  previous: string[],
): string[] {
  const allOption = options[0];
  const individualSubjects = options.filter((s) => s !== allOption);

  if (selected.includes(allOption)) {
    if (!previous.includes(allOption)) {
      return [allOption, ...individualSubjects];
    }
    return [];
  }

  if (individualSubjects.every((sub) => selected.includes(sub))) {
    return [allOption, ...individualSubjects];
  }
  return selected.filter((s) => s !== allOption);
}
